import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketingComponent } from './ticketing.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { ModalCreateTicketComponent } from './components/modal-create-ticket/modal-create-ticket.component';
import { TableTicketingComponent } from './components/table-ticket/table-ticket.component';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from '../../libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TicketingRoutingModule } from './ticketing-routing.module';

import { DetailTicketComponent } from './components/detail-ticket/detail-ticket.component';
import { MessageTicketComponent } from './components/message-ticket/message-ticket.component';

@NgModule({
  declarations: [
    TicketingComponent,
    TableTicketingComponent,
    ModalCreateTicketComponent,
    DetailTicketComponent,
    MessageTicketComponent
  ],
  imports: [
    CommonModule,
    NzCardModule,
    AntDModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LibsModule,
    NgxDaterangepickerMd,
    TicketingRoutingModule
  ],
  exports: [
    TicketingComponent,
    TableTicketingComponent,
    ModalCreateTicketComponent,
    DetailTicketComponent,
    MessageTicketComponent
  ]
})
export class TicketingModule { }
